// The application and the public client onboarding page are served from the same build on two
// hosts. The router keeps each host to its own routes (see router/index.js); the admin pages
// build client links from onboardingBase so they always point at the onboarding host.
//
// onboardingDomainLive: set to true once onboarding.sfc-uk.com resolves and is added in cPanel
// (and set ONBOARDING_URL=https://onboarding.sfc-uk.com in the API .env). Until then client links
// and the public form stay on the application host.
const hosts = {
  appHost: "sfc.systemstailormade.com",
  onboardingHost: "onboarding.sfc-uk.com",
  onboardingBase: "https://onboarding.sfc-uk.com",
  onboardingDomainLive: false,
};

export default hosts;

// Local development and any other host are left alone: no redirects, links use the current origin.
export function isOnboardingHost() {
  return window.location.hostname === "onboarding.sfc-uk.com";
}

export function isAppHost() {
  return window.location.hostname === "sfc.systemstailormade.com";
}

export function onboardingLink(token) {
  let base = window.location.origin;
  if (isAppHost() || isOnboardingHost()) {
    base = hosts.onboardingDomainLive ? hosts.onboardingBase : `https://${hosts.appHost}`;
  }
  return `${base}/client-onboarding/${token}`;
}
